export default import.meta.ROLLDOWN_FILE_URL_EGgIuQyJ7cAhs5XTHUTd2Q